import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/auth";
import Routes from "./routers";
import { ThemeProvider } from './context/theme';
import AppUpdateNotice from './components/AppUpdateNotice';

function App() {

  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes />
        </AuthProvider>
      </BrowserRouter>
      <AppUpdateNotice />
    </ThemeProvider>
  );
}

export default App;
